import React from "react";
import { Building2, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const logos = [{
  id: "l1",
  name: "Kunde Alpha",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_alpha.png"
}, {
  id: "l2",
  name: "Kunde Beta",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_beta.png"
}, {
  id: "l3",
  name: "Kunde Gamma",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_gamma.png"
}, {
  id: "l4",
  name: "Kunde Delta",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_delta.png"
}, {
  id: "l5",
  name: "Kunde Epsilon",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_epsilon.png"
}, {
  id: "l6",
  name: "Kunde Zeta",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_zeta.png"
}, {
  id: "l7",
  name: "Kunde Eta",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_eta.png"
}, {
  id: "l8",
  name: "Kunde Theta",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/reference_logo_theta.png"
}];
const locations = [{
  id: "loc1",
  name: "Einkaufszentrum Mitte, Berlin"
}, {
  id: "loc2",
  name: "Hauptbahnhof, München"
}, {
  id: "loc3",
  name: "Messegelände, Frankfurt"
}, {
  id: "loc4",
  name: "Flughafen Terminal 2, Hamburg"
}, {
  id: "loc5",
  name: "Kaufhaus Galerie, Köln"
}, {
  id: "loc6",
  name: "U-Bahn Station Rathaus, Stuttgart"
}, {
  id: "loc7",
  name: "Business Park Nord, Düsseldorf"
}, {
  id: "loc8",
  name: "Klinikum West, Leipzig"
}];
const referenceList = [{
  id: "ref1",
  title: "Galeria Kaufhof",
  description: "München am Stachus, Würzburg, Mannheim, Düren, Mönchengladbach, Regensburg"
}, {
  id: "ref2",
  title: "H & M",
  description: "Franken Center, Nürnberg"
}, {
  id: "ref3",
  title: "Olympia Einkaufszentrum",
  description: "München"
}, {
  id: "ref4",
  title: "Woolworth",
  description: "Frankfurt"
}, {
  id: "ref5",
  title: "Einkaufszentrum Mitte",
  description: "Berlin"
}, {
  id: "ref6",
  title: "Hauptbahnhof",
  description: "München"
}, {
  id: "ref7",
  title: "Messegelände",
  description: "Frankfurt"
}, {
  id: "ref8",
  title: "Kaufhaus Galerie",
  description: "Köln"
}];
export default function Referenzen() {
  return <section id="referenzen" className="py-24 md:py-40 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-primary mb-6">
            Referenzen
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Wir haben Kunden in ganz Deutschland und Österreich. Nachfolgend sehen Sie eine kleine Auswahl unserer erfolgreich durchgeführten Reinigungsaufträge.
          </p>
        </div>

        <Separator className="mb-16 opacity-20" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
          {referenceList.map((item, i) => <div key={item.id} data-index={i} className="group flex items-start gap-4 p-6 border border-border/50 rounded-sm bg-card/30 hover:bg-card transition-colors duration-300">
              <div className="mt-1 p-2 bg-primary/5 rounded-sm group-hover:bg-accent/10 transition-colors">
                <Building2 className="w-5 h-5 text-primary group-hover:text-accent transition-colors" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-primary mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-muted-foreground text-sm">
                  <MapPin className="w-3.5 h-3.5 shrink-0" />
                  <span>{item.description}</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-20 p-8 bg-muted/50 rounded-sm border border-border text-center">
          <p className="text-sm text-muted-foreground italic">Hier sehen Sie eine Auswahl unserer Referenzen. Wenn Sie mehr erfahren möchten, nennen wir Ihnen gerne weitere Projekte auf Anfrage.</p>
        </div>
      </div>
    </section>;
}